<template>
  <div class="notice" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          客服信息
        </el-text>
        <el-button-group>
          <el-button type="primary" @click="save()" :loading="loading.save">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="二维码">
        <el-upload list-type="picture-card" style="width: 100%;" v-model:file-list="data.file.file" :limit="1" :action="api.baseURL() + '/backend/file/upload'" :headers="api.tokenHeader()" multiple :on-error="() => ElMessage.error('上传失败')"
          :on-preview="(f) => util.previewElfile(f)" accept=".png,.jpg,.jpeg">
          <el-icon>
            <Plus />
          </el-icon>
        </el-upload>
      </el-form-item>
      <el-form-item label="客服描述">
        <el-input v-model="data.notice.content" type="textarea" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const loading = reactive({
  save: false,
})
const data = reactive({
  notice: {
    type: 'KF',
    kkey: '',
    hasShow: true,
    title: '',
    content: '',
    sort: 0,
    file: '',
  },
  file: { file: [] },
})

const getKf = () => {
  loading.save = true
  api.get('/backend/notice/getNoticeList', { params: { type: 'KF' } }).then((res) => {
    if (res.list.length > 0) {
      data.notice = res.list[0]
      data.file.file = util.json2Elfile(data.notice.file)
    }
    loading.save = false
  })
}
getKf()

const save = () => {
  loading.save = true
  const notice = JSON.parse(JSON.stringify(data.notice))
  notice.file = util.elfile2Json(data.file.file)
  if (!data.notice.id) {
    api.post('/backend/notice/addNotice', notice).then(() => {
      ElMessage.success('保存成功')
      getKf()
    }).finally(() => {
      loading.save = false
    })
  } else {
    notice.createDatetime = null
    api.post('/backend/notice/setNotice', notice).then(() => {
      ElMessage.success('保存成功')
      getKf()
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.notice {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>